import cx from 'classnames';
import type { MouseEventHandler, ReactNode } from 'react';
import type { IconProps } from '../Icon';
import { Icon } from '../Icon';
import styles from './styles.module.css';

export interface InputIconProps {
  icon: IconProps['name'];
  className?: string;
  disabled?: boolean;
  noTabFocus?: boolean;
  onIconClicked?: MouseEventHandler<HTMLButtonElement>;
}

export function InputIcon({ className, icon, disabled, onIconClicked, noTabFocus }: InputIconProps): ReactNode {
  return (
    <button
      className={cx(styles.InputIcon, className, {
        [styles.WithCursor]: !!onIconClicked,
        [styles.ValidStateIconColor]: icon === 'check' && !disabled,
        [styles.InvalidStateIconColor]: icon === 'cross' && !disabled,
        [styles.DisabledIcon]: !!disabled,
      })}
      disabled={disabled}
      type="button"
      tabIndex={noTabFocus ? -1 : 0}
      onMouseUp={onIconClicked}
    >
      <Icon fill name={icon} />
    </button>
  );
}
